import React, { useEffect } from "react";
import { createStackNavigator } from "@react-navigation/stack";
import OtherListView from "../../views/Other/ListView/ListView";
import BathroomMapView from "../../views/Bathrooms/MapView/BathroomsMapView";
import { STRINGS } from "../../constants";
import BathroomsDetailsView from "../../views/Bathrooms/DetailsView/BathroomsDetailsView";
import { Platform } from "react-native";
import BathroomsStore from "../../storage/bathroomsStore";
import { HeaderBackButton } from "@react-navigation/elements";

const Stack = createStackNavigator();

/**
 * BathroomStack Component
 *
 * Defines the stack navigator for the Bathroom feature.
 * Includes a ListView for bathroom options and a MapView for location visualization.
 */
const BathroomStack = () => {
  const { fetchBathrooms } = BathroomsStore();

  useEffect(() => {
    fetchBathrooms();
  }, [fetchBathrooms]);

  return (
    <Stack.Navigator
      initialRouteName="BathroomListView"
      screenOptions={{
        cardStyle: { flex: 1 },
      }}
    >
      {/* Bathroom ListView */}
      <Stack.Screen name="BathroomListView" options={{ title: STRINGS.bathroomTitle }}>
        {() => <OtherListView type="bathroom" />}
      </Stack.Screen>

      {/* Bathroom MapView */}
      <Stack.Screen
        name="BathroomMapView"
        component={BathroomMapView}
        options={{ title: STRINGS.bathroomTitle, headerLeft: () => null }}
      />
      {/* DetailsView Screen - Provides details about the bathroom */}
      <Stack.Screen
        name="BathroomDetailsView"
        component={BathroomsDetailsView}
        options={({ navigation }) => {
          const canGoBack = navigation.canGoBack();
          const hideNavigationBar = Platform.OS === "android" && !canGoBack ? { headerShown: false } : {};
          return {
            ...hideNavigationBar,
            headerBackTitle: STRINGS.back,
            ...(Platform.OS === "web" && !canGoBack
              ? {
                  headerLeft: () => (
                    <HeaderBackButton
                      tintColor="#000"
                      onPress={() => {
                        window.location.href = `${window.location.origin}/bathrooms`;
                      }}
                    />
                  ),
                }
              : {}),
          };
        }}
      />
    </Stack.Navigator>
  );
};
export default BathroomStack;
